export function commentMarkdownToPlainText(markdown: string) {
  return markdown
    .replaceAll(/\[([^\]\n]{0,500})\]\([^)\n]{0,2000}\)/g, '$1')
    .replaceAll(/\n{3,}/g, '\n\n')
    .trim();
}
